function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Utility to transform form annotations to legacy/report annotation format

const colorObjectToString = color => {
  if (!color) return 'undefined undefined undefined undefined';
  const {
    red,
    green,
    blue,
    alpha = 1
  } = color;
  return [red, green, blue, alpha].join(' ');
};
const rectObjectToString = rect => {
  if (!rect || !rect.origin || !rect.size) return null;
  const {
    origin: {
      x,
      y
    },
    size: {
      width,
      height
    }
  } = rect;
  return `{{${x}, ${y}}, {${width}, ${height}}}`;
};
const translate = {
  FreeText: ({
    text: _text = 'Text',
    fontName: _fontName = 'Helvetica',
    fontSize: _fontSize = 14
  }) => ({
    text: _text,
    fontName: _fontName,
    fontSize: _fontSize
  }),
  Highlight: ({
    rectArray: _rectArray = []
  }) => ({
    rectsString: _rectArray.map(rect => rectObjectToString(rect)).join('/')
  }),
  Ink: ({
    strokeWidth,
    width,
    pointArray: _pointArray = [],
    unsmoothed: _unsmoothed = 0
  }) => ({
    pathString: _pointArray.map(({
      x,
      y
    }) => `{${x}, ${y}}`).join('/') || '',
    width: width || strokeWidth || 0,
    unsmoothed: _unsmoothed
  }),
  Line: params => translate.Ink(_objectSpread(_objectSpread({}, params), {}, {
    unsmoothed: 1
  })),
  Note: ({
    text: label,
    color
  }) => ({
    content: JSON.stringify({
      label,
      color: colorObjectToString(color)
    })
  }),
  Info: () => ({})
};
const renderTypeMapping = {
  FreeText: 'freeTextAnnotation',
  Highlight: 'highlightAnnotation',
  Ink: 'inkAnnotation',
  Line: 'inkAnnotation',
  Note: 'noteAnnotation',
  Info: 'infoAnnotation'
};
function convertFormAnnotationToLegacyAnnotation(formAnn) {
  const {
    render,
    formType
  } = formAnn.content || formAnn;
  if (!render) return null;
  const {
    renderType,
    color,
    textColor,
    rect,
    rotation,
    page,
    alpha
  } = render;

  // Guard: return null if renderType is not recognized
  if (!renderType || !renderTypeMapping[renderType] || !translate[renderType]) return null;

  // For FreeText, use color for background and textColor for text
  let colorString;
  if (renderType === 'FreeText') {
    colorString = colorObjectToString(color);
  } else if (renderType === 'Note') {
    colorString = colorObjectToString(color);
  } else if (renderType === 'Line' || renderType === 'Ink') {
    // For line and ink annotations, incorporate alpha value into the color
    // The alpha can come from either the separate alpha property or the color object itself
    let effectiveAlpha = 0.5; // default fallback
    if (alpha !== undefined) {
      effectiveAlpha = alpha;
    } else if (color && color.alpha !== undefined) {
      effectiveAlpha = color.alpha;
    }
    const colorWithAlpha = color ? _objectSpread(_objectSpread({}, color), {}, {
      alpha: effectiveAlpha
    }) : {
      red: 0,
      green: 0,
      blue: 0,
      alpha: effectiveAlpha
    };
    colorString = colorObjectToString(colorWithAlpha);
  } else {
    colorString = colorObjectToString(color || textColor);
  }
  let textColorString;
  if (renderType === 'Note') {
    textColorString = textColor ? colorObjectToString(textColor) : undefined;
  } else {
    textColorString = textColor ? colorObjectToString(textColor) : undefined;
  }
  const translated = _objectSpread({
    id: formAnn.id
  }, translate[renderType](render));
  const rectString = rectObjectToString(rect);
  if (!rectString) return null; // Return null if we can't create a valid rectString

  const annotation = {
    id: formAnn.id,
    formType,
    rotation,
    pageNumber: page,
    rectString,
    colorString,
    color: color ? colorObjectToString(color) : undefined,
    textColor: textColorString,
    [renderTypeMapping[renderType]]: translated
  };
  return annotation;
}

// Converts a legacy rectString (e.g., '{{x, y}, {width, height}}') to a form rect object
const legacyRectStringToFormRect = rectString => {
  if (!rectString) return null;
  const match = rectString.match(/\{\{([\d.-]+), ([\d.-]+)\}, \{([\d.-]+), ([\d.-]+)\}\}/);
  if (!match) return null;
  return {
    origin: {
      x: parseFloat(match[1]),
      y: parseFloat(match[2])
    },
    size: {
      width: parseFloat(match[3]),
      height: parseFloat(match[4])
    }
  };
};

// Converts a legacy pathString (e.g., '{x1, y1}/{x2, y2}/...') to a form pointArray
const pathStringToPointArray = pathString => {
  if (!pathString) return [];
  return pathString.split('/').map(segment => {
    const match = segment.match(/\{([\d.-]+), ([\d.-]+)\}/);
    if (!match) return null;
    return {
      x: parseFloat(match[1]),
      y: parseFloat(match[2])
    };
  }).filter(Boolean);
};
export { convertFormAnnotationToLegacyAnnotation, legacyRectStringToFormRect, pathStringToPointArray };